export function MotivationalCardWidget() {
  return (
    <div className="relative rounded-2xl bg-white border border-slate-100/90 p-5 shadow-xs overflow-hidden flex flex-col justify-between min-h-[220px]">
      {/* Motivational Quotes */}
      <div className="z-10 relative">
        <p className="font-serif italic text-[14px] text-slate-800 leading-snug tracking-tight m-0">
          &ldquo;A small step every day<br />leads to big results.&rdquo;
        </p>
        <p className="font-['Ma_Shan_Zheng','Caveat',cursive] text-[13px] text-slate-500 mt-2 m-0 leading-normal tracking-wide">
          * 每天一點進步，<br />&nbsp;&nbsp;成就更好的自己。
        </p>
      </div>

      {/* Isometric 3D Steps & Victory Flag Illustration */}
      <div className="relative w-full h-[115px] -mb-2 pointer-events-none select-none flex items-end justify-end">
        <svg
          viewBox="0 0 200 110"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[185px] h-[105px] object-contain"
          aria-hidden="true"
        >
          {/* Ground ambient shadow */}
          <ellipse cx="120" cy="100" rx="70" ry="8" fill="#E2E8F0" opacity="0.8" />
          <ellipse cx="145" cy="98" rx="45" ry="6" fill="#CBD5E1" opacity="0.5" />

          {/* Step 1: Lowest Step (Bottom Left) */}
          {/* Top Face */}
          <polygon points="50,85 85,68 115,82 80,99" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="0.75" />
          {/* Left Face */}
          <polygon points="50,85 80,99 80,105 50,91" fill="#BFDBFE" />
          {/* Right Face */}
          <polygon points="80,99 115,82 115,88 80,105" fill="#3B82F6" />

          {/* Step 2: Middle Step */}
          {/* Top Face */}
          <polygon points="85,68 118,52 145,64 112,80" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="0.75" />
          {/* Left Face */}
          <polygon points="85,68 112,80 112,98 85,86" fill="#93C5FD" />
          {/* Right Face */}
          <polygon points="112,80 145,64 145,82 112,98" fill="#2563EB" />

          {/* Step 3: Highest Step Podium (Top Right) */}
          {/* Top Face */}
          <polygon points="120,48 152,32 178,44 146,60" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="0.75" />
          {/* Left Face */}
          <polygon points="120,48 146,60 146,85 120,73" fill="#60A5FA" />
          {/* Right Face */}
          <polygon points="146,60 178,44 178,69 146,85" fill="#1D4ED8" />

          {/* Victory Flagpole on Summit Podium */}
          <line x1="168" y1="38" x2="168" y2="10" stroke="#64748B" strokeWidth="2" strokeLinecap="round" />
          <circle cx="168" cy="9" r="1.8" fill="#F59E0B" />

          {/* Waving Blue Victory Flag */}
          <path
            d="M168 11 C174 9, 180 15, 188 12 L188 23 C180 26, 174 20, 168 22 Z"
            fill="#2563EB"
            stroke="#1D4ED8"
            strokeWidth="0.5"
          />
        </svg>
      </div>
    </div>
  );
}
